var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "25px",
    viewBox: "0 0 34 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home",
    transform: "translate(-943.000000, -4097.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(943.000000, 4097.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10.0454545,
    y: 5.15873016,
    width: 15.4545455,
    height: 13.8888889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5242865,17.0634921 L13.5227273,7.14285714 L22.7954545,12.1093232 L13.5242865,17.0634921 Z M33.6602542,5.39349415 C33.6602542,5.39349415 33.3282124,2.94382757 32.3085899,1.86536805 C31.0158611,0.449491082 29.5663562,0.442311987 28.9022727,0.359353562 C24.1442911,0 17.0073188,0 17.0073188,0 L16.9926812,0 C16.9926812,0 9.85570888,0 5.09811252,0.359353562 C4.43325856,0.442311987 2.98452405,0.449491082 1.69141006,1.86536805 C0.671787551,2.94382757 0.340130968,5.39349415 0.340130968,5.39349415 C0.340130968,5.39349415 0,8.26951916 0,11.145943 L0,13.8428895 C0,16.7193134 0.340130968,19.5953384 0.340130968,19.5953384 C0.340130968,19.5953384 0.671787551,22.0450049 1.69141006,23.1238633 C2.98452405,24.5393414 4.68363809,24.4946715 5.44016949,24.6430395 C8.16044683,24.9158451 17,25 17,25 C17,25 24.1442911,24.9888325 28.9022727,24.629479 C29.5663562,24.5465205 31.0158611,24.5393414 32.3085899,23.1238633 C33.3282124,22.0450049 33.6602542,19.5953384 33.6602542,19.5953384 C33.6602542,19.5953384 34,16.7193134 34,13.8428895 L34,11.145943 C34,8.26951916 33.6602542,5.39349415 33.6602542,5.39349415 Z",
    id: "Fill-584-Copy-2",
    fill: "#FF0000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e72078050248d4801923c37c3f2411d7.svg";
export { ForwardRef as ReactComponent };